const ChevronRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="Icon-module__icon-Ndb5 Icon-module__right-Ni0f"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 24 24 6h12L24 24l12 18H23.98L12 24Z"
      clipRule="evenodd"
    />
  </svg>
);
export default ChevronRight;
